<template>
  <div id="policyholder-login"
       class="background-darker-blue tfbins-login">
    <v-container class="tfbins-login-box">
      <h1 class="tfb-title-text-medium text-uppercase">Log In</h1>
      <ValidationObserver ref="obv" v-slot="{ handleSubmit }">
        <v-form @submit.stop.prevent="handleSubmit(logIn)">
          <v-row>
            <v-col cols="12">
              <text-input rules="required|min:4|max:60|all_allowed"
                          minlength="4"
                          maxlength="60"
                          label="Username/Email Address"
                          autocomplete="username"
                          v-model="userName"></text-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <text-input rules="required|min:4|max:99"
                          minlength="4"
                          maxlength="99"
                          label="Password"
                          v-model="passWord"
                          autocomplete="current-password"
                          type="password"></text-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-btn block
                     :disabled="formDisabled"
                     type="submit"
                     class="tfb-button background-red">Log In</v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
      <v-row>
        <v-col cols="12">
          <span v-if="registrationEnabled">
            <router-link :to="{ name: 'policyholderRegister'}"
                         hreflang="en-us">Register</router-link> |
          </span><router-link :to="{ name: 'policyholderForgotPassword'}"
                       hreflang="en-us">Forgot Password</router-link>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
  import { ValidationObserver } from 'vee-validate';
  import tfbMetaMixin from '@/mixins/metaInfo';
  import tfbHelperMixin from '@/mixins/helpers';

  export default {
    name: 'PolicyHolderLogin',
    mixins: [tfbMetaMixin, tfbHelperMixin],
    components: {
      ValidationObserver,
    },
    data() {
      return {
        userName: '',
        passWord: '',
        rememberLogin: '',
        formDisabled: false,
      };
    },
    computed: {
      metaPageTitle() {
        return 'Log In | PolicyHolder';
      },
      metaUrl() {
        return `${process.env.VUE_APP_ROOT_URI}/policyholder/login`;
      },
      registrationEnabled() {
        try {
          const allowRegistration = this.$store.getters['app/registrationEnabled'];
          return (allowRegistration && allowRegistration !== null && allowRegistration === 'Y');
        } catch (error) {
          return true;
        }
      },
    },
    async mounted() {
      this.$store.dispatch('app/clearErrorMessage');
      await this.$store.dispatch('app/doApplicationCheck', { sApplicationName: 'Policyholder', sTfbId: this.trackingId })
        .then((returnedStatus) => {
          if (returnedStatus === '') {
            if (this.isLoggedIn) {
              // Redirect where needed
              this.doRedirect();
            } else {
              // See if this is an SSO session
              const includedToken = this.$route.query.access_token;

              if (includedToken && includedToken !== '') {
                // We have a token, see if we can log in
                this.$store.dispatch('member/doSsoLogin', { sAccessToken: includedToken, sTfbId: this.trackingId })
                  .then((response) => {
                    this.$store.dispatch('app/logToULS', {
                      logLevel: 'Info',
                      logMessage: response,
                      fileName: 'Login.vue',
                      methodName: 'doSsoLogin-Success',
                      trackerId: this.trackingId,
                    });

                    if (response === 'invalid_grant') {
                      this.$store.dispatch('app/setErrorMessage', 'Username/Password Not Found');
                    }

                    if (response !== '') {
                      this.$store.dispatch('app/setErrorMessage', response);
                    } else {
                      // Redirect where needed
                      this.doRedirect();
                    }
                  })
                  .catch((error) => {
                    this.$store.dispatch('app/setErrorMessage', error.toString());
                    this.$store.dispatch('app/logToULS', {
                      logLevel: 'Error',
                      logMessage: error,
                      fileName: 'Login.vue',
                      methodName: 'doSsoLogin-Catch',
                      trackerId: this.trackingId,
                    });
                  });
              }
              this.$store.dispatch('app/setIsLoading', false);
            }
          } else {
            this.$store.dispatch('app/setErrorMessage', returnedStatus);
            this.$store.dispatch('app/setIsLoading', false);
            this.formDisabled = true;
          }
        })
        .catch((error) => {
          this.$store.dispatch('app/setErrorMessage', error);
          this.$store.dispatch('app/setIsLoading', false);
        });
    },
    methods: {
      async logIn() {
        this.$store.dispatch('app/setIsLoading', true);
        this.$store.dispatch('app/clearErrorMessage');
        this.$store.dispatch('app/logToULS', {
          logLevel: 'Info',
          logMessage: this.userName,
          fileName: 'Login.vue',
          methodName: 'doLogin-Start',
          trackerId: this.trackingId,
        });
        await this.$store.dispatch('member/doLogin', {
          sUserName: this.userName,
          sPassword: this.passWord,
          sCatchaText: 'kQMSVtPlYECzM1IX8WibEg',
          sTfbId: this.trackingId,
        })
          .then((response) => {
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Info',
              logMessage: response,
              fileName: 'Login.vue',
              methodName: 'doLogin-Response',
              trackerId: this.trackingId,
            });

            if (response === 'invalid_grant') {
              this.$store.dispatch('app/setErrorMessage', 'Username/Password Not Found');
              this.$store.dispatch('app/setIsLoading', false);
            }

            if (response !== '') {
              this.$store.dispatch('app/setErrorMessage', response);
              this.$store.dispatch('app/setIsLoading', false);
            } else {
              // Redirect where needed
              this.doRedirect();
            }
          })
          .catch((error) => {
            this.$store.dispatch('app/setErrorMessage', error.toString());
            this.$store.dispatch('app/setIsLoading', false);
            this.$store.dispatch('app/logToULS', {
              logLevel: 'Error',
              logMessage: error,
              fileName: 'Login.vue',
              methodName: 'doLogin-Catch',
              trackerId: this.trackingId,
            });
          });
      },
    },
    created() {
      this.$store.dispatch('app/setIsLoading', true);
      this.$store.dispatch('app/clearErrorMessage');
    },
  };
</script>
<style lang="scss">

  .tfbins-login {
    padding-top: 100px;
    padding-bottom: 100px;
  }

  .tfbins-login-box {
    background: $white;
    padding: 20px 50px;
    max-width: 500px;
    color: $tfb-darkest-blue;
  }
</style>
